import { render, staticRenderFns } from "./AddOtherFiles.vue?vue&type=template&id=ae076360&scoped=true&"
import script from "./AddOtherFiles.vue?vue&type=script&lang=js&"
export * from "./AddOtherFiles.vue?vue&type=script&lang=js&"
import style0 from "./AddOtherFiles.vue?vue&type=style&index=0&id=ae076360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae076360",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAlert,VBtn,VCol,VForm,VRow,VTextarea})
